import React, { useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useDidMount } from 'rooks';
import ScrollBarsContextProvider from '../../contexts/scrollBarsContext';
import { closeModules, openModal, toggleDisplaySize } from '../../redux/actions';
import { useDragAndDrop } from '../../utils/dragDropHelpers';
import MobileMenu from '../MobileMenu';
import ApiErrorModalLayout from '../Modal/layouts/ApiError';
import Navbar from '../Navbar';
import './style.scss';

const Dashboard = ({ children }) => {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const { onDragEnd, onDragStart } = useDragAndDrop(state, dispatch);

	const [isMobileMenuActive, toggleMobileMenu] = useState(false);
	const [screenSize, setScreenSize] = useState(window.innerWidth);

	//throw api error modal
	useEffect(() => {
		if (state.app.apiError) {
			dispatch(openModal(<ApiErrorModalLayout />, false));
		}
	}, [state.app.apiError, dispatch]);

	//updating screen size local state
	useDidMount(() => {
		window.addEventListener('resize', (e) => {
			setScreenSize(e.target.innerWidth);
		});
		return () => {
			window.removeEventListener('resize', (e) => {
				setScreenSize(e.target.innerWidth);
			});
		};
	});

	//toggle isTabletSize global flag
	useEffect(() => {
		const isTabletSize = state.app.isTabletSize;
		const isMobileSize = state.app.isMobileSize;
		if (screenSize > 1024) {
			if (isTabletSize) {
				dispatch(toggleDisplaySize('tablet', false));
			}
			if (isMobileSize) {
				dispatch(toggleDisplaySize('mobile', false));
			}
		} else if (screenSize <= 1024 && screenSize > 768) {
			if (!isTabletSize) {
				dispatch(toggleDisplaySize('tablet', true));
			}
			if (isMobileSize) {
				dispatch(toggleDisplaySize('mobile', false));
			}
		} else if (screenSize <= 768) {
			if (!isTabletSize) {
				dispatch(toggleDisplaySize('tablet', true));
			}
			if (!isMobileSize) {
				dispatch(toggleDisplaySize('mobile', true));
			}
		}
	}, [screenSize, dispatch, state.app.isTabletSize, state.app.isMobileSize]);

	const handleToggleHamburger = (status) => {
		if (state.filter.mobileActive || state.editor.mobileActive) {
			dispatch(closeModules(status));
		} else {
			toggleMobileMenu(status);
		}
	};

	const isHamburgerOpen =
		isMobileMenuActive || state.filter.mobileActive || state.editor.mobileActive;

	return (
		<div className="home-wrapper">
			<Navbar isHamburgerOpen={isHamburgerOpen} toggleHamburger={handleToggleHamburger} />
			<main className="dashboard">
				<DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
					<ScrollBarsContextProvider>{children}</ScrollBarsContextProvider>
				</DragDropContext>
			</main>
			<MobileMenu active={isMobileMenuActive} toggleMenu={toggleMobileMenu} />
		</div>
	);
};

export default Dashboard;
